<template>
  <div class="flex items-center gap-1 text-sm">
    <font-awesome-icon v-if="permissionsOwner !== undefined" :icon="isServiceOwner ? faUser : faUserSlash" />
    <span class="xl:inline" :class="{ hidden: !props.inPopup }">
      <template v-if="isServiceOwner">
        {{ t("ngp/admin_bar/view/own") }}
      </template>
      <template v-else-if="permissionsOwner !== undefined">
        <translation keypath="ngp/admin_bar/view/foreign">
          <template #owner
            ><b>{{ permissionsOwner }}</b></template
          >
        </translation>
      </template>
    </span>
  </div>
</template>

<script setup lang="ts">
import { faUser, faUserSlash } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import { Translation, useI18n } from "vue-i18n";
import { usePermissions } from "../../util/permissions";

const props = defineProps<{
  inPopup: boolean;
}>();

const { t } = useI18n();
const { permissionsOwner, isServiceOwner } = usePermissions();
</script>
